var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tasks-page-wrapper"},[_vm._m(0),_vm._v(" "),_c('TasksManager',{ref:"tasksManager"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row mt-2 mb-2"},[_c('div',{staticClass:"col-md-12"},[_c('h2',{staticClass:"text-center"},[_vm._v("Gerenciamento de Tarefas")])])])])
}]

export { render, staticRenderFns }